var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFrom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#copy-from_svg__clip0_1656_36653)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515864"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.998 13.09c0 1.1-.71 2.03-1.73 2.39-.15.06-.28.08-.43.13.01-.08.01-.52 0-1.31.52-.19.86-.65.86-1.18V2.53c0-.7-.58-1.27-1.3-1.27h-7.35c-.54 0-1.04.34-1.23.84-.79-.01-1.23-.01-1.31 0 .02-.15.06-.25.1-.4.35-.99 1.32-1.71 2.44-1.71h7.35c1.43 0 2.59 1.14 2.59 2.53v10.56l.01.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.952 3.38h-7.36c-.37 0-.73.08-1.06.23-.91.4-1.54 1.27-1.54 2.3v10.56c0 1.39 1.17 2.53 2.59 2.53h7.35c1.04 0 1.95-.61 2.36-1.5.15-.32.24-.65.24-1.03V5.91c0-1.39-1.17-2.53-2.59-2.53h.01zm1.3 13.09c0 .7-.58 1.27-1.3 1.27h-7.36c-.71 0-1.3-.57-1.3-1.27V5.91c0-.7.58-1.27 1.3-1.27h7.35c.71 0 1.3.57 1.3 1.27v10.56h.01z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.827 12.536l-3.182-3.182a.5.5 0 010-.707l3.182-3.182a.5.5 0 11.707.707L21.205 8.5H30.5v1h-9.295l2.329 2.329a.5.5 0 11-.707.707z",
    fill: "#515864"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-from_svg__clip0_1656_36653"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v19H0z"
  })))));
}
export default SvgCopyFrom;